export const m = {
  common: {
    t1: '体验Demo',
    t2: '互动指南系统',
    t3: '静态指南系统',
    t4: '多媒体信息发布系统',
    t5: '自助寻车缴费系统',
    t6: '室内导航系统',
    t7: 'AR导航系统',
    t8: '路易寻',
    t9: '云招商',
    t10: '了解更多',
    t11: '预约演示',
    t12: '咨询顾问',
    t13: '购物中心',
    t14: '医院',
    t15: '写字楼',
    t16: '交通',
    t17: '教育',
    t18: '观看视频',
    t19: '首页',
    t20: '产品',
    t21: '解决方案',
    t22: '关于我们',
    t23: '基础产品',
    t24: '应用产品',
    t25: '语言',
    t26: '联络我们',
    t27: '公司介绍',
    t28: '新闻中心',
    t29: '硬件产品',
    t30: '自助机 CKIOSK C1',
    t31: '自助机 CKIOSK C2',
    t32: '自助机 CKIOSK D1',
    t33: '运维监护仪 CKIOSK M1',
    taxtData: [
      {
        title: "3D地图",
        url: "static/window/ids/icon1.png",
        html: `在主页上显示其当前位置可以使用户更好地了解其周围的空间,<br> 可360度旋转、放大缩小。`,
        html1: `在主页上显示其当前位置可以使用户更好地了解其周围的空间,可360度旋转、放大缩小。`
      },
      {
        title: "当前位置",
        url: "static/window/ids/icon2.png",
        html: `使用系统时，地图会以用户面向的方向定位，<br>  从而使方向更易于理解。`,
        html1: `使用系统时，地图会以用户面向的方向定位，从而使方向更易于理解。`
      },
      {
        title: "最短线路",
        url: "static/window/ids/icon3.png",
        html: `可计算出到达目的地的最快路线，<br> 并显示估计的全程时间。`,
        html1: `可计算出到达目的地的最快路线，并显示估计的全程时间。`
      },
      {
        title: "无障碍线路",
        url: "static/window/ids/icon4.png",
        html: `如果希望避开自动扶梯和楼梯，<br>用户可以轻松地通过电梯查看路线。`,
        html1: `如果希望避开自动扶梯和楼梯，用户可以轻松地通过电梯查看路线。`
      },
      {
        title: "高度调整",
        url: "static/window/ids/icon5.png",
        html: `一键放下纵向格式的用户界面即可轻松访问。`,
        html1: `一键放下纵向格式的用户界面即可轻松访问。`
      },
      {
        title: "设施快速搜索",
        url: "static/window/ids/icon6.png",
        html: `方便的一键式导航到所有常见的便利设施和突出显示的位置。`,
        html1: `方便的一键式导航到所有常见的便利设施和突出显示的位置。`
      },
      {
        title: "多语言",
        url: "static/window/ids/icon7.png",
        html: `已翻译成20多种语言，可确保欢迎每位客户。`,
        html1: `已翻译成20多种语言，可确保欢迎每位客户。`
      },
      {
        title: "关键字搜索",
        url: "static/window/ids/icon8.png",
        html: `使客户能够搜索产品，品牌和服务。`,
        html1: `使客户能够搜索产品，品牌和服务。`
      },
      {
        title: "反向寻车",
        url: "static/window/ids/icon9.png",
        html: `与现有系统的灵活集成使用户可以在复杂的空间内放置汽车。`,
        html1: `与现有系统的灵活集成使用户可以在复杂的空间内放置汽车。`
      },
      {
        title: "智能广告",
        url: "static/window/ids/icon10.png",
        html: `通过动态媒体（包括高清视频，图像和Adobe®Flash®动画）<br>吸引用户的注意力。`,
        html1: `通过动态媒体（包括高清视频，图像和Adobe®Flash®动画）吸引用户的注意力。`
      },
      {
        title: "意见反馈",
        url: "static/window/ids/icon11.png",
        html: `用户可在软件中反馈使用意见，<br>帮助我们改善服务和体验。`,
        html1: `用户可在软件中反馈使用意见，帮助我们改善服务和体验。`
      },
      {
        title: "扫码至手机",
        url: "static/window/ids/icon12.png",
        html: `用户可通过扫描线路指引的二维码，打开手机地图，<br>通过对接蓝牙等实时定位系统可以实现实时导航。`,
        html1: `用户可通过扫描线路指引的二维码，打开手机地图，通过对接蓝牙等实时定位系统可以实现实时导航。`
      }
    ],
  },
  home: {
    t1: '帮助客户实现空间数字化体验',
    t2: '全球领先的室内地图解决方案提供商',
    t3: '以用户为中心的全场景用户体验产品',
    t4: '创互提供从方案的咨询、设计、数据采集、建模到智能应用产品开发、实施的全方位解决方案，帮助企业驱动数字化转型和提升场景的用户体验。',
    productData: [
      {
        navUrl: "./static/window/product/icon0.png",
        bgUrl: "static/window/home/1.png",
        cName: "one map",
        eName: "",
        shortName: "",
        codeUrl: "",
        link: "onemap",
        des: `借助在线制图工具cmappax的能力 ，打造企业的室内地图数据中台 ，对数据进行采集、计算、存储、加工，以统一标准和口径为数据标准 ，存储为大数据资产层 ，以此数据逻辑来为企业提供高效的服务 。藉由我们的服务 ，企业高关联性、独有且能复用的业务和数据能够得以沉淀。<br>
              通过开放全端API实现数据打通，彻底解决企业在室内地图上的重复投入 、重复建设、重复维护、体验不一致、信息孤岛等顽疾，突破性地实现one service、one map， 打造企业完整的“一张图”。`
      },
      {
        navUrl: "./static/window/product/icon1.png",
        bgUrl: "static/window/home/2.png",
        cName: "互动指南系统",
        eName: "Interactive Dictionary System",
        shortName: "IDS",
        codeUrl: "",
        link: "ids",
        des: `突破传统单一的标识系统 ，集互动性 、智能性 、体验性于一体的全新互动指南应用方案。一套方案实现导视 、导购 、宣传 、娱乐、资讯、留言、寻车缴费、会员服务等多种功能，带给顾客新颖的、互动式的体验，有效满足顾客信息查询的需求，大大分担服务台用户咨询的压力。结合视觉、听觉和触觉的多维立体服务平台，在业主和用户之间架设了一条新颖、生动、实用、高效的沟通桥梁。`
      },
      {
        navUrl: "./static/window/product/icon2.png",
        bgUrl: "static/window/home/3.png",
        cName: "静态指南系统",
        eName: "Static Directory System",
        shortName: "SDS",
        codeUrl: "",
        link: "sds",
        des: `系统基于互联网或局域网、结合触摸屏、显示屏、红外感应等技术实时显示总索引、楼层索引等信息，管理员可通过后台进行地图和品牌数据的维护更新，当没有用户靠近时屏幕播放广告，用户靠近时，通过红外感应，显示总索引或楼层信息，解决了传统标识由于信息发生改变，须到现场人工操作，无法后台维护，导致人力成本高，屏幕价值低等问题。`
      },
      {
        navUrl: "./static/window/product/icon3.png",
        bgUrl: "static/window/home/4.png",
        cName: "多媒体信息发布系统",
        eName: "Multimedia Information Display System",
        shortName: "MIDS",
        codeUrl: "",
        link: "mids",
        des: `系统提供基于互联网或局域网的多媒体信息发布功能，可以让政府/企业、医院、银行、交通、学校、楼宇、营业厅、商场、酒店、餐饮、卖场、连锁机构等基于网络构建一个可在大屏发布视频、图片、字幕、网页、app、微信等多种媒体矩阵的多媒体信息发布平台，为用户提供低成本高质量的多媒体信息云端服务。可对内容布局以及排期的进行管理。解决传统画面信息需要人工现场操作、不能提前设置，导致发布时间长，人力成本高等问题 。`
      },
      {
        navUrl: "./static/window/product/icon4.png",
        bgUrl: "static/window/home/5.png",
        cName: "自助寻车缴费系统",
        eName: "Car Search Payment System",
        shortName: "CSPS",
        codeUrl: "",
        link: "csps",
        des: `自助寻车缴费一体机是一款应用于停车场管理系统用于帮助用户找车、缴费并提供24小时自助服务的前端设备。<br>
          系统具有液晶触控式，支持刷脸找车、车牌找车、车位找车以及扫码支付、刷脸支付等功能，功能实用、操作简单方便，实现了无人值守式智能收费。特别是对于大型停车场管理系统，采用自助缴费终端，可以大大减提高出口通行效率，同时还大大降低了停车场人工管理费用，提升了物业管理水平。`
      },
      {
        navUrl: "./static/window/product/icon5.png",
        bgUrl: "static/window/home/6.png",
        cName: "室内导航系统",
        eName: "Indoor Navigation System",
        shortName: "INS",
        codeUrl: "",
        link: "indoor",
        des: `系统以自研的地图引擎为基础，可结合WIFI、蓝牙、UWB等多种定位方式，帮助用户快速到达目的地。提供针对不同的业务场景的定位精度要求，可提供不同行业的室内定位技术方案。`
      },
      {
        navUrl: "./static/window/product/icon6.png",
        bgUrl: "static/window/home/7.png",
        cName: "AR导航系统",
        eName: "AR Navigation System",
        shortName: "AR",
        codeUrl: "",
        link: "ar",
        des: `通过AI视觉识别技术对物理空间进行建模，依托先进的AI人工智能技术进行定位导航，帮助用户快速找到目标位置,并可结合活动进行AR营销 ，无须硬件投入、无须现场施工，定位精度高，精度在1米左右。`
      },

      {
        navUrl: "./static/window/product/icon9.png",
        bgUrl: "static/window/home/10.png",
        cName: "商业经营可视化",
        eName: "Business Intelligence System (BI)",
        shortName: "",
        codeUrl: "",
        link: "bi",
        des: `不受地域平台限制,令你随时随地即时查看数据自主研发的H5图表， 数据是以秒速更新， 即时留意到現場最新状况,可同时间在不同平台上查看,不受地域平台限制。<br />
        室内地图即时显示，用户可即时选择地图中的数据查看,简单直接。相人员借助可视化数据分析平台，辅助人工操作的同时将数据进行关联分析,并制作出不同的分析图表，完整展示数据分析的过程和不同的数据走向。提高经营管理和决策效率,为企业带来经济效益和企业竞争力。以帆软分析图表为例，可保存为不同格式，供相关人员调整或调阅。`
      },

      {
        navUrl: "./static/window/product/icon10.png",
        bgUrl: "static/window/home/11.png",
        cName: "广告预约系统",
        eName: "Advertisement System (ADS)",
        shortName: "",
        codeUrl: "",
        link: "ads",
        des: `基于数字地图，建立全场景（实体广告位、电子广告屏等）广告位资源可视化管理、在线预约、在线审批的一体化系统。`
      },

      {
        navUrl: "./static/window/product/icon7.png",
        bgUrl: "static/window/home/8.png",
        cName: "路易寻",
        eName: "easy2walk",
        shortName: "",
        link: "easytowalk",
        codeUrl: "./static/window/product/easy2walkCode.png",
        des: `在一个陌生的城市，语言不通、网络差异的情况下，能在商场和商场快速、容易地找到想去的店铺，并查看导航路线和消费方式，少花冤枉钱，少走冤枉路。方便简单直接便用，不用想，不用问，不用等，实现点对点导航。<br>`
      },
      {
        navUrl: "./static/window/product/icon8.png",
        bgUrl: "static/window/home/9.png",
        cName: "云招商",
        eName: "easylease",
        shortName: "",
        codeUrl: "",
        link: "easylease",
        des: `云招商是一个线上云招互动系统，在招商过程中不需要面对面面谈，和招商顾问不需要准备大量的资料，在一个平台就可展示招商资料，包括项目业态 ，面积，已租出信息。<br>
            云招商同时是一个招商顾问和客户沟通平台，招商顾问联络客户，客户亦可同时间联络在线的招商顾问查询有关招商讯息。`
      }
    ],
    t5: `创互科技自主研发的在线制图工具cmappax，提供从室内地图数据的采集、建模、生产，开放全端API实现数据打通能力，支持在线绘制不同个性风格的、精美的2D/3D地图，
    <br />打开网页就能查看和编辑，云端实时保存，可在线实时编辑文件，权限安全可控。`,
    t5_mobile: '创互科技自主研发的在线制图工具cmappax，提供从室内地图数据的采集、建模、生产，开放全端API实现数据打通能力，支持在线绘制不同个性风格的、精美的2D/3D地图，打开网页就能查看和编辑，云端实时保存,可在线实时编辑文件，权限安全可控。',

    t6: '创互科技深知首次评估和持续评估的重要性，并在项目管理中贯彻践行，无论是项目设计、实施工作开始之前，还是开展期间都严格执行评估分析程序。我们亦凭借这些丰富的专业经验对外提供单独的咨询服务。咨询团队由一线运营经验的管理人员、资深设计总监、资深IT总监组成，提供规划前的方案评估、在建项目评估和微调，以及建成项目的潜力和再开发机会评估。以往的经验显示，无论是独立购物中心还是大型的城市综合体，经过深思熟虑的设计不仅能够对项目在美学上的成功产生根本的影响，同时也有助于项目在经济方面取得成功。在充分发掘商机的基础上，如果能辅以卓有成效的设计，可以有效提高品牌美誉度、提升用户体验、降低运营成本。',
    t7: '客户证言',
    t8: `我们的客户来自于多个行业，遍布中国内地及香港<span style='font-size: 0.32rem;' class="num">30</span>多个城市`,
    customerAppraiseData: [
      {
        title: "九龙仓某负责人",
        des:
          "我们一直在寻找技术领先、同时与我们步调一致的合作伙伴。创互先进的产品技术是他们的核心竞争力，更重要的是我们很欣赏创互团队“帮助人”的理念，在产品体验过程中处处能体会到这样的用心，每一项定制化的功能，甚至每一个按钮的设置，都是以顾客为出发点，在这个点上和我们的理念一拍即合。我们相信，专注和用心的供应商能够把我们的服务宗旨深入传达到每一个顾客心中，这是我们最为看重的。",
        logoUrl: "./static/window/customAppraise/logo1.png"
      },
      {
        title: "新鸿基某负责人",
        des:
          "新鸿基和创互的合作时机非常及时，他们设计的地图数据统一管理平台（one map）是我们一直在寻找的解决方案。它让我们市场部能通过一个后台实现网站、微信公众号、小程序、IDS、反向寻车等系统地图的统一管理。我们的运营人员终于可以从重复修改，反复和不同供应商沟通中解脱出来，为我们解决了一个大难题。对于商业地产行业而言，数字化运营体系的建立势在必行，但同时也有很长的路要走。未来希望和创互有更多的创新合作，推动我们的项目走向更加智能化的运营。",
        logoUrl: "./static/window/customAppraise/logo2.png"
      },
      {
        title: "湘雅医院某负责人",
        des:
          "从初识创互到正式建立合作过程中的每一个环节，接触到的售前、销售顾问、实施专员、售后处理等创互的每一个员工都具备极其专业的素养。此外，提交的方案，更是体现创互行业解决方案的专业性。产品性能、功能、售后流程、服务皆有圈内同行背书，颇受好评，交给这样的服务商比较放心。",
        logoUrl: "./static/window/customAppraise/logo3.png"
      },
      {
        title: "卓越集团某负责人",
        des:
          "在选定合作伙伴的时候，我们团队花了不少时间，细致的比较了几家国内外品牌的区别，最后选择了创互。原因在于他们是国内最早研发互动指南系统的软硬件厂商，而且到目前为止仍在智慧商业解决方案方面处于领先。新零售战略的落地需要这样行业经验丰富又有极致创新能力的伙伴，我们双方都能在合作中实现长远的发展。",
        logoUrl: "./static/window/customAppraise/logo4.png"
      }
    ],
    t9: '我们服务的行业客户',
    t10: '了解更多行业解决方案',

  },
  m1: {
    t1: '赋能传统设备智慧升级',
    t2: "安卓深度定制系统，稳定可靠<br />4G通信能力，赋能传统设备<br />内置蓝牙通讯，实现设备智能联动<br />设备工况数据实时采集，现场状态尽在掌握<br />丰富外部接口，创造更多可能<br />迷你尺寸，灵活适应不同部署环境",
    t2_mobile: "安卓深度定制系统，稳定可靠<br />4G通信能力，赋能传统设备<br />内置蓝牙通讯，实现设备智能联动<br />设备工况数据实时采集，现场状态尽在掌握<br />丰富外部接口，创造更多可能<br />迷你尺寸，灵活适应不同部署环境",
    t3: '应用场景',
    t4: '购物中心、写字楼、医院、学校、机场、高铁站等',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',
    listData2: [
      {
        url: "./static/window/m1/jiance.png",
        title: "断电监测"
      },
      {
        url: "./static/window/m1/kaiji.png",
        title: "通电开机"
      },
      {
        url: "./static/window/m1/guanji.png",
        title: "断电关机"
      },
      {
        url: "./static/window/m1/baohu.png",
        title: "断电保护"
      }
    ],
    listData2_B: [
      {
        url: "./static/window/m1/kaiguan.png",
        title: "定时开关"
      },
      {
        url: "./static/window/m1/kongzhi.png",
        title: "屏幕控制"
      },
      {
        url: "./static/window/m1/caiji.png",
        title: "状态采集"
      },
      {
        url: "./static/window/m1/yuanchen.png",
        title: "远程控制"
      }
    ],
    t7: '技术规格',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `8核2G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "储存",
        html: `2G RAM 16GROM`
      },
      {
        url: "./static/window/m1/m1-dianchi.png",
        title: "电池",
        html: `4000mAh`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `支持 IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "以太网",
        html: `1个 10/100/1000M<br />自适应`
      },
      {
        url: "./static/window/m1/c1-4g.png",
        title: "4G网络",
        html: `移动、电信、联通`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB接口",
        html: `1×USB接口`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "wifi接口",
        html: `1×wifi接口`
      },
      {
        url: "./static/window/m1/c1-lanya.png",
        title: "蓝牙",
        html: `1×蓝牙接口`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "RS232接口",
        html: `1xRS232接口`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "电源",
        html: `1 x DC电源接口`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "尺寸",
        html: `设备25*115*156mm<br />包装27*117*158mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "重量",
        html: `0.125Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~ 40℃<br />储存温度：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `8核2G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "储存",
        html: `2G RAM <br />16GROM`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianchi.png",
        title: "电池",
        html: `4000mAh`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `支持 IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "以太网",
        html: `1个 10/100/<br />1000M自适应`
      },
      {
        url: "./static/window/mobileM1C1C2D1/4g.png",
        title: "4G网络",
        html: `移动、电信、<br />联通`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB接口",
        html: `1×USB接口`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi接口",
        html: `1×wifi接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/lanya.png",
        title: "蓝牙",
        html: `1×蓝牙接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "RS232接口",
        html: `RS232接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "电源",
        html: `1 x DC电源<br />接口`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "尺寸",
        html: `设备25*115<br />*156mm包装<br />27*117*158<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "重量",
        html: `0.125Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~<br />40℃储存温度<br />-20℃ ~ 55℃`
      }
    ],
  },
  c1: {
    t1: '标准版',
    t2: "全高清摄像头<br />43‘4k全视觉高清触显一体大屏<br />国内知名定向降噪麦克风<br />采用国际知名电容触摸屏、反应快、精度高<br />CHAUNVE OS提供应用市场管理、霸屏、远程控制、灰度升级等服务",
    t2_mobile: "全高清摄像头<br />43‘4k全视觉高清触显一体大屏<br />国内知名定向降噪麦克风<br />采用国际知名电容触摸屏、反应快、精度高<br />CHAUNVE OS提供应用市场管理、霸屏、远程控<br />制、灰度升级等服务",
    t3: '应用场景',
    t4: '购物中心、写字楼、医院、学校、机场、高铁站等',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "电容触摸"
      },
      {
        url: "./static/window/c1/4k.png",
        title: "4K显示"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "使用统计"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "语音服务"
      }
    ],
    t7: '技术规格',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `6核3.0G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "存储",
        html: `PCIE<br />SSD固态硬盘120g`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "内存",
        html: `DDR4 2133 8G`
      },
      {
        url: "./static/window/m1/c1-xianka.png",
        title: "显卡",
        html: `显存4G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "显示屏",
        html: `43‘3840×2160`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "电容触摸",
        html: `支持10点触摸`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "摄像头",
        html: `1080P高清摄像头`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "喇叭",
        html: `2x3W(立体声)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `支持 IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "以太网",
        html: `1个 10/100/1000M<br />自适应`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB3.0",
        html: `4×USB3.0接口`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMI接口（2.0）`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "COM接口",
        html: `1×COM接口`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "电源",
        html: `1 x DC电源接口`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "尺寸",
        html: `设备394*171*1017mm<br />包装394*171*1017mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "重量",
        html: `16.5Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~ 40℃<br />储存温度：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `6核3.0G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "存储",
        html: `PCIE SSD<br />固态硬盘<br />120g`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "内存",
        html: `DDR4 2133<br />8G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianka.png",
        title: "显卡",
        html: `显存4G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "显示屏",
        html: `43’<br />3840×2160`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "电容触摸",
        html: `支持10点触<br />摸`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "摄像头",
        html: `1080P高清<br />摄像头`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "喇叭",
        html: `2x3W(立体声)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `支持 IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "以太网",
        html: `1个 10/100/<br />1000M自适应`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB3.0",
        html: `4×USB3.0接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />接口（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "COM接口",
        html: `1×COM接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "电源",
        html: `1 x DC电源<br />接口`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "尺寸",
        html: `设备394*171<br />*1017mm包装<br />394*171*1017<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "重量",
        html: `16.5Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~<br />40℃储存温度<br />-20℃ ~ 55℃`
      }
    ],
  },
  c2: {
    t1: '标准版',
    t2: "全高清摄像头<br />43‘4k全视觉高清触显一体大屏<br />国内知名定向降噪麦克风<br />采用国际知名电容触摸屏、反应快、精度高<br />CHAUNVE OS提供应用市场管理、霸屏、远程控制、灰度升级等服务",
    t3: '应用场景',
    t4: '购物中心、写字楼、医院、学校、机场、高铁站等',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "电容触摸"
      },
      {
        url: "./static/window/c1/4k.png",
        title: "4K显示"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "使用统计"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "语音服务"
      }
    ],
    listData2_B: [
      {
        url: "./static/window/c2/shebao.png",
        title: "插入社保卡"
      },
      {
        url: "./static/window/c2/erweima.png",
        title: "二维码识别"
      },
      {
        url: "./static/window/c2/zhengjian.png",
        title: "证件识别"
      }
    ],
    mobile2_B: [
      {
        url: "./static/window/c2/shebaoicon.png",
        title: "插入社保卡"
      },
      {
        url: "./static/window/c2/erweimaicon.png",
        title: "二维码识别"
      },
      {
        url: "./static/window/c2/zhengjianicon.png",
        title: "证件识别"
      }
    ],
    t7: '技术规格',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `6核3.0G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "存储",
        html: `PCIE<br />SSD固态硬盘120g`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "内存",
        html: `DDR4 2133 8G`
      },
      {
        url: "./static/window/m1/c1-xianka.png",
        title: "显卡",
        html: `显存4G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "显示屏",
        html: `43‘3840×2160`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "电容触摸",
        html: `支持10点触摸`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "摄像头",
        html: `1080P高清摄像头`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "喇叭",
        html: `2x3W(立体声)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `支持 IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "以太网",
        html: `1个 10/100/1000M<br />自适应`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB3.0",
        html: `4×USB3.0接口`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMI接口（2.0）`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "COM接口",
        html: `1×COM接口`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "电源",
        html: `1 x DC电源接口`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "尺寸",
        html: `设备394*171*1017mm<br />包装394*171*1017mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "重量",
        html: `16.5Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~ 40℃<br />储存温度：-20℃ ~ 55℃`
      },
      {
        url: "./static/window/m1/c2-shebaoka.png",
        title: "社保卡 ",
        html: `插入社保卡识别`
      },
      {
        url: "./static/window/m1/c2-erweima.png",
        title: "二维码",
        html: `二维码识别`
      },
      {
        url: "./static/window/m1/c2-zhengjian.png",
        title: "证件",
        html: `证件识别`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "系统",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `6核3.0G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "存储",
        html: `PCIE SSD<br />固态硬盘<br />120g`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "内存",
        html: `DDR4 2133<br />8G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianka.png",
        title: "显卡",
        html: `显存4G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "显示屏",
        html: `43’<br />3840×2160`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "电容触摸",
        html: `支持10点触<br />摸`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "摄像头",
        html: `1080P高清<br />摄像头`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "喇叭",
        html: `2x3W(立体声)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `支持 IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "以太网",
        html: `1个 10/100/<br />1000M自适应`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB3.0",
        html: `4×USB3.0接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />接口（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "COM接口",
        html: `1×COM接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "电源",
        html: `1 x DC电源<br />接口`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "尺寸",
        html: `设备394*171<br />*1017mm包装<br />394*171*1017<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "重量",
        html: `16.5Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "电源输入",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~<br />40℃储存温度<br />-20℃ ~ 55℃`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shebao.png",
        title: "社保卡",
        html: `插入社保卡<br />识别`
      },
      {
        url: "./static/window/mobileM1C1C2D1/erwei.png",
        title: "二维码",
        html: `二维码识别`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhengjian.png",
        title: "证件",
        html: `证件识别`
      }
    ],
  },
  d1: {
    t1: '桌面版',
    t2: "全高清摄像头<br />10.1' 全视觉高清触显一体大屏<br />国内知名定向降噪麦克风<br />采用国际知名电容触摸屏、反应快、精度高<br />CHAUNVE OS提供应用市场管理、霸屏、远程控制、灰度升级等服务",
    t2_mobile: "全高清摄像头<br />10.1' 全视觉高清触显一体大屏<br />国内知名定向降噪麦克风<br />采用国际知名电容触摸屏、反应快、精度高<br />CHAUNVE OS提供应用市场管理、霸屏、远程控<br />制、灰度升级等服务",
    t3: '应用场景',
    t4: '购物中心、写字楼、医院、学校、机场、高铁站等',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "电容触摸"
      },
      {
        url: "./static/window/d1/gaoqing.png",
        title: "高清显示"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "使用统计"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "语音服务"
      }
    ],
    t7: '技术规格',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "系统",
        html: `Android 9.0`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `4核1.8 G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "存储",
        html: `RAM 2G`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "内存",
        html: `16G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "显示屏",
        html: `10.1‘1200*1920`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "电容触摸",
        html: `支持10点触摸`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "摄像头",
        html: `200W像素摄像头`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "喇叭",
        html: `2x1W(立体声)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `支持 IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "以太网",
        html: `1个 10/100/1000M<br />自适应`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB2.0",
        html: `2×USB2.0接口`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMI接口（2.0）`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "电源",
        html: `1 x DC电源接口`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "尺寸",
        html: `设备300*150*180mm<br />包装320*170*200mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "重量",
        html: `0.25Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "电源输入",
        html: `5V/2A`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~ 40℃<br />储存温度：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "系统",
        html: `Android 9.0`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `4核1.8 G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "存储",
        html: `RAM 2G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "内存",
        html: `16G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "显示屏",
        html: `10.1’<br />1200*1920`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "电容触摸",
        html: `支持10点触<br />摸`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "摄像头",
        html: `200W像素摄<br />像头`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "喇叭",
        html: `2x1W(立体声)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `支持 IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "以太网",
        html: `1个 10/100/<br />1000M自适应`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB2.0",
        html: `2×USB2.0接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />接口（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "音频",
        html: `1×音频接口`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "电源",
        html: `1 x DC电源<br />接口`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "尺寸",
        html: `设备300*150<br />*180mm包装<br />320*170*200<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "重量",
        html: `0.25Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "电源输入",
        html: `5V/2A`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "工作环境",
        html: `工作温度：0 ~<br />40℃储存温度<br />-20℃ ~ 55℃`
      }
    ],
  },
  cmappax: {
    t1: '可在线绘制地图的工具',
    t2: 'cmappax 是什么？',
    t3: ' cmappax是一款可在线绘制地图的工具。<br />支持在线绘制不同个性风格的、精美的2D/3D地图，打开网页就能查看和编辑，云端实时保存；<br />可在线实时编辑文件，权限安全可控。',
    t4: '2D/3D室内地图及导航指引系统的发明者（国家发明专利号：201310272792.3）',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',

    t7: ' 无需下载安装，打开网址',
    t7_1: '立即编辑',

    t8: '随时随地任您使用',
    t9: '任意地方、电脑只要联网即可顺畅访问、绘制和编辑地图。',
    t10: '高效',
    t11: '快速绘制，只需一步',
    t12: '鼠标拖拽，即可实现绘制。一步到位，室内外地图效果清晰可见。',
    t13: '快速调整，只需一点',
    t14: '鼠标一点，即可切换多套主题，一键点击即可发布查看地图效果。',
    t15: '安全',
    t16: '无需特意保存，电脑断电文件不丢失',
    t17: '系统会对您的输入做自动保存，不用担心断网断电导致编辑的内容丢失。',
    t18: '小小工具 多多可能',
    t19: '只要能想 就能做到',
    t20: '可绘制精美、个性的2D/3D地图，满足不同业务场景需求',
    t20_mobile: '可绘制精美、个性的2D/3D地图，<br />满足不同业务场景需求',
    t21: '即将上线...',
    t22: '点击左键控制地图',
    t23: '双击下滑继续浏览',
    t24: '按住右键旋转地图',
    t25: '开放API',
    t26: '团队接入，增强产力',
    t27: '通过cmappax地图API，可把地图应用在全世界中不同的平台展示，令你制作的地图无所不在。地图的数据会经过加密存储，令数据更加安全。',
    t28: '满足平台/团队接入',
    t29: '支持第三方账号登录，满足第三方组织架构授权，<br />与应用平台无缝衔接。',
    t30: '享受无差别体验',
    t31: '  提供全套编辑能力，并逐步优化提升，与cmappax地图的编辑、<br />体验毫无差别。',
    t32: '保障数据安全',
    t33: '无需特意保存，电脑断电文件不丢失',
    t34: '数据经过加密存储，全程https加密，确保数据从访问、传输到存储安全无忧',
    t35: '应用场景解决方案',
    t36: '无缝衔接',
    t37: 'Cmappax是由深圳创互科技有限公司凭借自主研发的产品、专业的3D地图，高效率的、全自由度的多平台地图绘制工具。为众多平台提供室内<br />地图技术支援以及精准的室内定位技术为核心，为商场、办公楼、医院、学校、公共园区等客户量身定制室内导购系统，提供定制化服务。',
    t38: '即刻体验',
    listData1: [
      {
        img: "./static/window/cmappax/icon1.png",
        title: "多能力",
        des: "具备快速拆分、合并、路径连接、布尔运算、POI设定等操作"
      },
      {
        img: "./static/window/cmappax/icon2.png",
        title: "多图层",
        des: "根据不同业务需要，支持按需调用不同的图层信息"
      },
      {
        img: "./static/window/cmappax/icon3.png",
        title: "多皮肤",
        des: "具备多种地图皮肤一按切换，满足不同设计需要"
      },
      {
        img: "./static/window/cmappax/icon4.png",
        title: "多主题",
        des: "支持一个后台创建不同主题的地图，满足个性化展示需求"
      },
      {
        img: "./static/window/cmappax/icon5.png",
        title: "多权限",
        des: "自主设定不同的权限管理，满足差异化管理需要"
      },
      {
        img: "./static/window/cmappax/icon6.png",
        title: "多平台",
        des: "支持不同平台调用，满足多业务场景的需求"
      }
    ],
  },
  consult: {
    t1: '专注创造价值，专业缔造完美',
    t2: '创互科技深知首次评估和持续评估的重要性，并在项目管理中贯彻践行，无论是项目设计、实施工作开始之前，还是开展期间都严格执行评估分析程序。我们亦凭借这些丰富的专业经验对外提供单独的咨询服务。咨询团队由一线运营经验的管理人员、资深设计总监、资深IT总监组成，提供规划前的方案评估、在建项目评估和微调，以及建成项目的潜力和再开发机会评估。以往的经验显示，无论是独立购物中心还是大型的城市综合体，经过深思熟虑的设计不仅能够对项目在美学上的成功产生根本的影响，同时也有助于项目在经济方面取得成功。在充分发掘商机的基础上，如果能辅以卓有成效的设计，可以有效提高品牌美誉度、提升用户体验、降低运营成本。'
  },
  onemap: {
    t1: '新一代地图数据统一管理平台',
    t2: '新一代地图数据中台',
    t3: '借助在线制图工具cmappax的能力，打造企业的室内地图数据中台，对数据进行采集、计算、存储、加工，以统一标准和口径为数据标准，存储为大数据资产层，以此数据逻辑来<br />为企业提供高效的服务。藉由我们的服务，企业高关联性、独有且能复用的业务和数据能够得以沉淀。<br />通过开放全端API实现数据打通，彻底解决企业在室内地图上的重复投入、重复建设、重复维护、体验不一致、信息孤岛等顽疾，突破性地实现 one service、one map ，打造企业<br />完整的“一张图”。',
    t3_mobile: '借助在线制图工具cmappax的能力 ，打造企业的室内地图数据中台，对数据进行采集、计算、存储、加工，以统一标准和口径为数据标准，存储为大数据资产层，以此数据逻辑来为企业提供高效的服务。藉由我们的服务，企业高关联性、独有且能复用的业务和 数据能够得以沉淀。<br />通过开放全端API实现数据打通，彻底解决企业在室内地图上的重复投入、重复建设、重复维护、体验不一致、信息孤岛等顽疾，突破性地实现one service、 one map，打造企业完整的“一张图”。',
    t4: '系统优势',
    taxtData: [
      {
        title: "一致的客户体验",
        url: "./static/window/onemap/a.png",
        html: `不同的客户都会得到、不同的平台均可得到一致的客户体验。`,
        html1: `不同的客户都会得到、不同的平台均可得到一致的客户体验。`
      },
      {
        title: "API",
        url: "./static/window/onemap/b.png",
        html: `该API可供不同的应用平台调用，满足不<br>同应用平台数据调用需求，并确保数据始<br>终是最新且一致的。`,
        html1: `该API可供不同的应用平台调用，满足不同应用平台数据调用需求，并确保数据始终是最新且一致的。`
      },
      {
        title: "动态显示选项",
        url: "./static/window/onemap/c.png",
        html: `地图可动态变化，可根据需要展示不同信息。`,
        html1: `地图可动态变化，可根据需要展示不同信息。`
      },
      {
        title: "速度快",
        url: "./static/window/onemap/d.png",
        html: `用户可在后台自主调整和更新数据；可调<br>整的数据包括空间信息、路径信息、POI<br>数据、场景、纹理、特效和主题等。`,
        html1: `用户可在后台自主调整和更新数据；可调整的数据包括空间信息、路径信息、POI数据、场景、纹理、特效和主题等。`
      },
      {
        title: "集中管理",
        url: "./static/window/onemap/e.png",
        html: `所有地图都通过集中管理进行更新。<br>您只需进行一次更改，所有地图数据<br>就会同时更新：屏幕，手机和网站等。`,
        html1: `所有地图都通过集中管理进行更新。您只需进行一次更改，所有地图数据就会同时更新：屏幕，手机和网站等。`
      }
    ],
  },
  ids: {

    t1: '以简单直观的方式显示复杂的方向信息',
    t2: '互动指南系统是一个综合的解决方案，以简单直观的方式显示复杂的方向信息',
    t3: '突破传统单一的标识系统，集互动性、智能性、体验性于一体的全新互动指南应用解决方案，以简单直观的方式显示复杂的方向信息，具有导视、宣传、资讯、留言、寻车、缴费、等多种功能，用户可通过最少的交互找到所需要的信息，带给顾客新颖的、互动式的体验，有效满足顾客信息查询的需求，大大分担服务台用户咨询的压力，在业主和用户之间架设了一条新颖、生动、实用、高效的沟通桥梁。',

    t4: '屏幕作为公共场所中顾客交流的最直接和重要的入口',
    t5: '创互的硬件上无缝集成到任何公共场所，同时确保所有焦点都集中在数字屏幕上，采用最新的软硬件技术，为客户提供兼具美感和实用性的方案。同时，能通过手机和现场的数字屏幕作出互动，使用户得到超出预期的惊喜体验。',

    t6: '创互，为客户体验树立了新的标准',
    t7: '我们的互动指南系统具有许多功能，并且经过10多年的发展和测试。让我们为您推荐有利于您的项目并为您的客户带来更好的体验的功能！',


    t8: 'one map、one cms，打造统一后台管理系统',
    t9: '借助创互的one map地图库，',
    t9_1: '打造企业的室内地图数据中台，对数据进行采集、计算、存储、加工，同时统一标准和口径，进而形成数据标准，再进行存储，<br />形成大数据资产层，进而提供高效的服务。',

    t9_mobile: '借助创互的one map地图库，',
    t9_mobile_1: "打造企业的室内地图数据中台，对数据进行采集、计算、存储、加工，同时统一标准和口径，进而形成数据标准，再进行存储，形成大数据资产层，进而提供高效的服务。",

    t10: '创互已在全球安装了16,000多个屏幕',
    t11: ' 我们的客户来自多个行业，包括九龙仓集团、恒隆集团、新鸿基集团、华润置地、万<br />科集团等，为客户带来了极致和超前的用户体验 。我们以用户为中心，确保我们提供<br />的解决方案可在不同的行业，不同的场景流畅地使用。',
    t11_mobile: '  我们的客户来自多个行业，包括九龙仓集团、恒隆集团、新鸿基集团、华润置地、万科集团等，为客户带来了极致和超前的用户体验。我们以用户为中心，确保我们提供的解决方案可在不同的行业，不同的场景流畅地使用。',
    listData2: [
      {
        title: "UHD 4K显示技术"
      },
      {
        title: "多点触控技术"
      },
      {
        title: "人脸识别技术"
      },
      {
        title: "语音识别技术"
      }
    ],
    listData2_R: [
      {
        title: "摄像头"
      },
      {
        title: "麦克风"
      },
      {
        title: "RFID"
      },
      {
        title: "QR Code"
      }
    ],
    listData3: [
      {
        url: "static/window/ids/device1.png",
        title: "横屏落地式"
      },
      {
        url: "./static/window/interactive/device2.png",
        title: "竖屏落地式"
      },
      {
        url: "./static/window/interactive/device3.png",
        title: "竖屏壁挂/嵌入式"
      },
      {
        url: "./static/window/interactive/device4.png",
        title: "横屏壁挂/嵌入式"
      },
      {
        url: "./static/window/interactive/device5.png",
        title: "手机微信/小程序/H5/APP"
      }
    ]
  },
  sds: {
    t1: '快速有效的指示',
    t2: '静态指南系统是您数字化平台的绝佳补充。它们使您能够即时传达关键方向的信息，包括每个楼层的信息和便利设施。<br />它们也是进行消息传递和促销的绝佳选择，并且可以成为广告系列或针对性的基于位置的广告系列的一部分。',
    t2_mobile: '静态指南系统是您数字化平台的绝佳补充。它们使您能够即时传达关键方向的信息，包括每个楼层的信息和便利设施。<br />它们也是进行消息传递和促销的绝佳选择，并且可以成为广告系列或针对性的基于位置的广告系列的一部分。',
    t3: ' 我们曾经经历过：黑板报、艺术字、喷绘、灯箱等传统广告<br />发布型态，画面单一、不易更新、承载内容少等缺陷。',
    t3_mobile: ' 我们曾经经历过：黑板报、艺术字、喷绘、灯箱等传统广告<br />发布型态，画面单一、不易更新、承载内容少等缺陷。',
    t4: '现在，我们来到了数字控制时代，并且不断的技术创新，增加了交互性，传感器等，让承载的内容和功能不断丰富。',
    t5: '解决了传统标识由于信息发生改变,须到现场人工操作，无法后台维护，导致人力成本高，屏幕价值低等问题。',
    t6: '默认广告',
    t7: '红外感应',
    t8: '传统灯箱',
    t9: '系统优势',
    listData2: [
      {
        url: "./static/window/sds/list2_icon1.svg",
        url1: "static/mobile/sds/3.png",
        title: "画面单一"
      },
      {
        url: "./static/window/sds/list2_icon2.svg",
        url1: "static/mobile/sds/4.png",
        title: "成本高"
      },
      {
        url: "./static/window/sds/list2_icon3.svg",
        url1: "static/mobile/sds/5.png",
        title: "不易更新"
      }
    ],
    listData3: [
      {
        url: "./static/window/sds/list3_icon1.svg",
        url1: "static/mobile/sds/6.png",
        title: "画面丰富"
      },
      {
        url: "./static/window/sds/list3_icon2.svg",
        url1: "static/mobile/sds/7.png",
        title: "交互性"
      },
      {
        url: "./static/window/sds/list3_icon3.svg",
        url1: "static/mobile/sds/8.png",
        title: "传感器"
      }
    ],
    listData4: [
      {
        url: "./static/window/sds/a.png",
        title: "动态显示"
      },
      {
        url: "./static/window/sds/b.png",
        title: "集中管理"
      },
      {
        url: "./static/window/sds/c.png",
        title: "媒体播放"
      },
      {
        url: "./static/window/sds/d.png",
        title: "一致的硬件设计"
      }
    ]

  },
  mids: {
    t1: '你的流动广告屏，减少不必要的印刷品',
    t2: '媒体发布，一按上传',
    t3: ' 创互开发了一个复杂的基于云的媒体计划平台，因此您可以充分利用您的数字媒体功能。<br />支持跨多种屏幕类型的多种媒体格式，所有格式均通过一天中的时间和日历日进行计划播放。<br />单个屏幕可以划分为多个区域，并分别进行安排以播放静态图像，动画序列或带有音频的高清视频。',
    t4: '媒体面板',
    t5: '各种形状或形式的媒体面板都可以满足您的要求。<br>壁挂式，台式安装或集成到目录的后部，它们可为您传递消息，租户促销和广告需求提供灵活性和控制力。',
    t5_mobile: '各种形状或形式的媒体面板都可以满足您的要求。壁挂式，台式安装或集成到目录的后部，它们可为您传递消息，租户促销和广告需求提供灵活性和控制力。',
    t6: '媒体管理',
    t7: '借助系统的媒体管理功能，可在系统直接管理素材，并可在全线上操作，布局设置、节目管理，素材管理，审批管理等。',
    t9: '人脸识别应用',
    t10: '多媒体信息发布系统的中的人脸识别，采用了AI摄像头，我们的AI可以分析到顾客的性别，年龄，猜测顾客喜好，精准推送出适合顾客的广告，增强广告宣传效果。',
    t11: '<img style="width:.2rem;margin-right:.1rem;" src="static/window/mids/ai/i0.png" alt="">AI摄像头',
    t12: '数据分析',
    t13: '人脸识别',
    t14: '增强会员<br>归属感',
    t15: '精准投放',
    listData2: [
      {
        url: "./static/window/mids/ai/i0.png",
        title: "AI摄像头",
        delay: 2
      },
      {
        url: "./static/window/mids/ai/i1.png",
        title: "数据分析",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i2.png",
        title: "人脸识别",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i3.png",
        title: "增强会员归属感",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i4.png",
        title: "精准投放",
        delay: 5
      }
    ],
    listData3: [
      {
        url: "./static/window/mids/manage/1.png",
        title: "布局设置"
      },
      {
        url: "./static/window/mids/manage/2.png",
        title: "节目管理"
      },
      {
        url: "./static/window/mids/manage/3.png",
        title: "素材管理"
      },
      {
        url: "./static/window/mids/manage/4.png",
        title: "设备管理"
      }
    ]
  },
  csps: {
    t1: '寻车缴费，快人一步',
    t2: "寻车缴费不用等",
    t3: '创互的自助寻车缴费系统，是一台集合缴费，寻车一体化设计的系统。<br />系统根据车辆入场时的数据，自动计算出车辆所需缴纳的费用，车主可在自助缴费机中使用纸币、硬币、银行卡等方式进行缴费，或者直接通过微信平台、支付宝进行电子缴费。',
    t4: '反向寻车',
    t5: ' 凭车牌号, 车位号,刷脸轻松寻车，车主在自助寻车缴费系统即可查询到车辆所在位置，并以3D地图的方式展示出车主所在位置到车辆所在位置的地图，同时间可扫码到手机，使用手机导航，可轻松取车。',
    t6: '刷脸寻车，刷脸支付',
    t7: '人脸断点导航智能停车场，只需要站在自助寻车缴费系统，就可以直接寻车和支付。',
    listData1: [
      {
        url: "./static/window/csps/list1_icon1.png",
        url1: './static/mobile/csps/icon1.png',
        title: "刷脸寻车"
      },
      {
        url: "./static/window/csps/list1_icon2.png",
        url1: './static/mobile/csps/icon2.png',
        title: "车牌寻车"
      },
      {
        url: "./static/window/csps/list1_icon3.png",
        url1: './static/mobile/csps/icon3.png',
        title: "车位寻车"
      },
      {
        url: "./static/window/csps/list1_icon4.png",
        url1: './static/mobile/csps/icon4.png',
        title: "停车缴费"
      }
    ]
  },
  indoor: {
    t2: '帮助您快速找到目的地',
    t3: '系统依托地图引擎，可结合WIFI、蓝牙、UWB等多种定位方式，帮助用户快速到达目的地。提供针对不同的业务场景的定位业务,可提供不同行业的室内定位解决方案。',
    t4: '创互，为客户体验树立了新的标准',
    t5: '我们的室内导航系统适用于各大型室内场所，导航线路实时呈现，帮助用户快速到达目的地。系统可以在APP、微信公众号、小程序等平台运行，<br />具有许多功能，并且经过10多年的发展和测试。让我们为您推荐有利于您的项目并为您的客户带来更好的体验的功能！',
    t6: '创互，为客户提供了领先的定位技术',
    t7: '我们经过多年的研究，发展出高精度定位技术，提供业内最优秀的定位服务产品，可以与第三方系统对接，实现数据的互通互联，不影响对方系统运行。',
    listData3_0: [
      {
        url: "./static/window/indoor/list3_icon1.png",
        title: "低流量消耗",
        des: "结合WIFI、蓝牙、UWB等多种定位方式<br>几乎无流量消耗"
      },
      {
        url: "./static/window/indoor/list3_icon2.png",
        title: "高成功率",
        des: "结合WIFI、蓝牙、UWB等多种定位方式<br>定位成功率高达99.6%"
      },
      {
        url: "./static/window/indoor/list3_icon3.png",
        title: "高精度",
        des: "结合WIFI、蓝牙、UWB等多种定位方式<br>整体精度达2-5米"
      }
    ],
    listData3_1: [
      {
        url: "./static/window/indoor/list3_icon4.png",
        title: "毫秒级响应",
        des: "IP定位速度小于0.2S"
      },
      {
        url: "./static/window/indoor/list3_icon5.png",
        title: "高覆盖",
        des: "基站、WI-FI覆盖率高达99%"
      },
      {
        url: "./static/window/indoor/list3_icon6.png",
        title: "低内耗",
        des: "CPU和内存占用率低"
      }
    ],
    listData1_0: [
      {
        url: "./static/window/indoor/list1_image1.png",
        title: "购物中心"
      },
      {
        url: "./static/window/indoor/list1_image2.png",
        title: "办公楼"
      },
      {
        url: "./static/window/indoor/list1_image3.png",
        title: "医院"
      },
      {
        url: "./static/window/indoor/list1_image4.png",
        title: "学校"
      },
      {
        url: "./static/window/indoor/list1_image5.png",
        title: "机场"
      },
      {
        url: "./static/window/indoor/list1_image6.png",
        title: "交通"
      }
    ],
  },
  ar: {
    t1: '新一代导航系统',
    t2: '  通过AI视觉识别技术对物理空间进行建模，依托先进的AI人工智能<br />技术进行定位导航，帮助用户快速找到目标位置；<br />无须硬件投入；无须现场施工；定位精度高，精度在1米左右；',
    t2_mobile: '通过AI视觉识别技术对物理空间进行建模，依托先进的AI人工智能技术进行定位导航，帮助用户快速找到目标位置；无须硬件投入；无须现场施工；定位精度高，精度在1米左右；',
    t3: '产品架构',
    t4: 'AR营销',
    t5: ' 在导航过程中，根据用户的位置和用户画像，智能推荐用户附近的营销活动信息；<br />商户的信息展示，包括人均消费、评分、营业时间等信息；<br />商户的优惠券推荐，通过AR展示商户的优惠券，用户可直接领取；<br />商户投放的广告展示，在商业服务中心，通过AR展示场景内商户投放的AR广告，为线下的商户引流；',
    listData1: [
      {
        url: "./static/window/ar/list1_icon1.png",
        title: "无需硬件"
      },
      {
        url: "./static/window/ar/list1_icon2.png",
        title: "无需施工"
      },
      {
        url: "./static/window/ar/list1_icon3.png",
        title: "米级精度"
      }
    ],
  },
  easylease: {
    t1: '您的在线招商顾问',
    t2: '多项目',
    t3: '展示集团下所有的项目，提供多维度的数据分析报告。将招<br />商数据多维度可视化的呈现，并实时共享招商工作进展，提<br />升商户服务质量、提高运营者管理能力。',
    t3_mobile: ' 展示集团下所有的项目，提供多维度的数据分析报告。将招<br />商数据多维度可视化的呈现，并实时共享招商工作进展，提升商户服务质量、提高运营者管理能力。',
    t4: "单项目",
    t5: "展示单个项目的商场展示，依托海量大数据，追踪顾客<br />消费行为，进行商业智能分析，从而快速构建精准营销<br />体系，将差异化的营销策略全面落地，轻松提升客户粘<br />度，提高转化率。",
    t5_mobile: '展示单个项目的商场展示，依托海量大数据，追踪顾客<br />消费行为，进行商业智能分析，从而快速构建精准营销<br />体系，将差异化的营销策略全面落地，轻松提升客户粘<br />度，提高转化率。',
    t6: '专属客服',
    t7: '招商顾问和客户沟通平台，招商顾问联络客户，客户亦可<br />同时间联络在线的招商顾问查询有关招商讯息，切实解决<br />客户在商业洽谈中信息不及时、不准确和沟通成本过高等<br />痛点，颠覆传统招商模式。',
    t7_mobile: " 招商顾问和客户沟通平台，招商顾问联络客户，客户亦可<br />同时间联络在线的招商顾问查询有关招商讯息，切实解决<br />客户在商业洽谈中信息不及时、不准确和沟通成本过高等<br />痛点，颠覆传统招商模式。",
    t8: "可视化招商",
    t9: "带您体验不一样的招商体验，多业态展示，可一键筛选显示",
    t10: '便捷的招商系统',
    t11: "还在使用平面图介绍项目吗？必须带客户去现场才能展现真实环境吗？项目特色如何更好的体现？<br />云招商线上系统，带你快速招商！",
    listData2: [
      {
        url: "./static/window/easylease/list2_image1.png",
        title: "出租",
        des: "一键筛选出租的商铺，并在地图显示",
        des1: "一键筛选出租的商铺，并在地图<br>显示"
      },
      {
        url: "./static/window/easylease/list2_image2.png",
        title: "面积",
        des: "显示每间商铺的面积，让您更好的选择",
        des1: "显示每间商铺的面积，让您更好<br>的选择"
      },
      {
        url: "./static/window/easylease/list2_image3.png",
        title: "位置",
        des: "商铺的位置一目了然，选您喜欢的位置吧",
        des1: "商铺的位置一目了然，选您喜欢<br>的位置吧"
      }
    ],
    listData3_1: [
      {
        url: "./static/window/easylease/list3_icon1.png",
        title: "项目信息",
        des: "招商信息了如指掌"
      },
      {
        url: "./static/window/easylease/list3_icon2.png",
        title: "周边环境",
        des: "项目周边交通、环境"
      },
      {
        url: "./static/window/easylease/list3_icon3.png",
        title: "项目环境",
        des: "可查看项目实景信息 "
      },
      {
        url: "./static/window/easylease/list3_icon4.png",
        title: "在线沟通",
        des: "可和招商顾问实时沟通"
      },
      {
        url: "./static/window/easylease/list3_icon5.png",
        title: "快速分享",
        des: "一键分享位置相关信息"
      },
      {
        url: "./static/window/easylease/list3_icon6.png",
        title: "在线预定",
        des: "心仪位置一键预定"
      },
      {
        url: "./static/window/easylease/list3_icon7.png",
        title: "集中管理",
        des: "实时更新招商数据，可对位置的状态、面积等进行修改"
      },
      {
        url: "./static/window/easylease/list3_icon8.png",
        title: "统计分析",
        des: "可对用户使用数据进行分析"
      }
    ]
  },
  easy2walk: {
    t1: '路与路之间就是简单',
    t2: '在一个陌生的城市，语言不通、网络差异的情况下能在商场和商场快速容易找到想买的商品和想吃的美食并查看导航路线和消费方式。',
    t3: '商场与商场之间容易找到',
    t4: `Easy2Walk路易寻让你轻松地来往不同的商场景点 ,<br />无需使用不同的软件你都可以容易找到你就近的商<br />场位置同时间可以店与店的导航同时间可以店与店<br />的导航附近的商场`,
    t4_mobile: ` Easy2Walk路易寻让你轻松地来往不同的商场景点
    ,场位置同时间可以店与店的导航同时间可以店与店的导航附近的商场。`,
    t5: '简单直接让你找到店铺',
    t6: `路易寻含有模拟导航系统,简单设定起点和终点<br />就可以根据导航快速找出您想去的店铺。`,
    t6_mobile: '路易寻含有模拟导航系统,简单设定起点和终点就可以根据导航快速找出您想去的店铺。',
    t7: '付款方式简单让你知道',
    t8: `在一个陌生的地方, 你未必知道你的付款方式<br />能否使用 Easy2Walk路易寻轻松提供付款资讯<br />让您购物时做好准备 。`,
    t8_mobile: ` 在一个陌生的地方， 你未必知道你的付款方式能否使用 Easy2Walk 路易寻轻松提供付款资讯让您购物<br>时做好准备。`,
    t9: '推广方式',
    listData1: [
      {
        url: "./static/window/easytowalk/list1_icon1.png",
        title: "海外推广",
        des:
          "旅客去到一个陌生的地方，人生路不熟找不到路，语言不通、<br>怕菜式不合吃、买了不好的东西，怕找路不方便。",
        des1:
          "旅客去到一个陌生的地方，人生路不熟找不到路，语言不通、怕菜式不合吃、买了不好的东西，怕找路不方便。"
      },
      {
        url: "./static/window/easytowalk/list1_icon2.png",
        title: "城市推广",
        des:
          "对政府可推动当地旅游发展大帮助，管理和推动<br>都是十分容易加強城市的竞争力。",
        des1:
          "对政府可推动当地旅游发展大帮助，管理和推动都是十分容易加強城市的竞争力。"
      },
      {
        url: "./static/window/easytowalk/list1_icon3.png",
        title: "商场推广",
        des:
          "减少客户排队询问的时间，让消费者手机<br>扫二维码即可找到自己想去的商铺。",
        des1:
          "减少客户排队询问的时间，让消费者手机扫二维码即可找到自己想去的商铺。"
      }
    ]
  },
  about: {
    t1: '创互公司：给客户带来价值',
    t2: '公司在飞速发展，服务的客户与日俱增，但无论走得多远，<br />我们都将本着给客户带来价值的价值观，服务好每一个<br />客户，与您一同乘帆远航。',
    t2_mobile: '公司在飞速发展，服务的客户与日俱增，但无论走得多远，我们都将本着给客户带来价值的价值观，服务好每一个客户，与您一同乘帆远航。',
    t3: '公司介绍',
    t4: '深圳市创互科技有限公司成立于2007年，拥有“2D/3D地图的显示及指引或导航方法”的国家发明专利技术。专注于提供数字化基建的地图能力，帮助客户实现空间数字化体验，产品<br />专注于室内地图在人工智能、大数据、云计算及物联网等方面的应用。<br />公司围绕自主知识产权的室内地图的技术和能力。相继推出了CMAPPAX、ONE MAP、互动指南系统、静态指南系统、多媒体信息发布系统、自助寻车缴费系统、路易寻、云招商等产<br />品，产品广泛应用于购物中心、机场、写字楼、医院等大型室内空间。<br />创造人与空间，物与空间的万物互联的数字化世界，是“创互”的由来。聚焦最后一公里，致力于全球领先的室内地图解决方案提供商，成为一家数据公司，一家物联网企业，通过我们<br />的能力和服务去连接所有的人和行业，为构建万物互联的数字世界而努力奋斗，引领物联网新时代。<br />',
    t4_mobile: "深圳市创互科技有限公司成立于2007年，拥有2D/3D地图的显示及指引或导航方法”的国家发明专利技术。专注于提供数字化基建的地图能力，帮助客户实现空间数字化体验，产品专注于室内地图在人工智能、大数据、云计算及物联网等方面的应用。<br />公司围绕自主知识产权的室内地图的技术和能力。相继推出了CMAPPAX、ONE MAP、互动指南系统、静态指南系统、多媒体信息发布系统、自助寻车缴费系统、路易寻、云招商等产品，产品广泛应用于购物中心、机场、写字楼、医院等大型室内空间。<br />创造人与空间，物与空间的万物互联的数字化世界，是“创互”的由来。聚焦最后一公里，致力于全球领先的室内地图解决方案提供商，成为一家数据公司，一家物联网企业，通过我们的能力和服务去连接所有的人和行业，为构建万物互联的数字世界而努力奋斗，引领物联网新时代。",
    t5: '创互自创办自今，十多年深耕，作为行业引领者，创造出多个"第一"：',
    t6: '生产出中国第一台42寸高清触控一体机;',
    t7: '打造中国第一个"商场电子导购系统";',
    t8: '获得了2D/3D室内地图及导航指引系统的发明者(国家发明专利号：201310272792.3);',
    t9: '研发出中国第一个具有自主知识产权的地图行业工具软件"cmappax";',
    t10: '推出了中国第一个地图数据中台产品"one map";',
    t11: '企业文化',
    t12: '我们的使命',
    t13: '通过我们的能力和服务去帮助更多的人和行业，让社会更加美好',
    t14: '我们的愿景',
    t15: '成为行业的、国家和社会的骄傲',
    t16: "我们的价值观",
    t17: '诚信、 敬业、 创新、 客户第一、 团队合作、 事情极致',
    t18: '我们的经营理念',
    t19: '悦近远来',
    t20: '联系我们',
    fontList: [
      { value: "2020年5月，创互发布OS计划。", diFlag: true },
      { value: "2020年5月，IDS新平台上线。" },
      { value: "2020年5月，共智会重庆分会、上海分会成立。" },
      { value: "2020年4月，创互参与发起的全球协作平台“共智会”成立。" },

      { value: "2020年3月，室内地图行业工具最新品牌 cmappax 上线发布。" },
      { value: "2019年12月，路易寻全球商场地图系统上线。", diFlag: true },
      { value: "2019年11月，创互和海康联合打造智慧监控系统。" },

      { value: "2019年9月，创互签约北京地标中国尊项目。" },
      { value: "2019年5月，创互医疗事业部成立。" },
      {
        value:
          "2019年2月，创互和九龙仓香港旗下海港城、荷里活广场、时代广场建立战略。"
      },
      { value: "2019年1月，创互北京分公司成立。" },
      { value: "2018年11月，创互武汉分公司及研发中心成立。", diFlag: true },
      { value: "2018年10月，创互和平安联合打造智慧监控项目。" },
      {
        value:
          "2018年9月，创互签约腾讯新总部腾讯滨海大厦项目，并陆续为其全球办公室提供找员工及会议室系统。"
      },

      {
        value:
          "2018年8月，创互和香港老牌四大家族之一利希慎旗下购物中心建立合作。"
      },
      { value: "2018年5月，九龙仓长沙IFS项目成功上线。" },
      {
        value:
          "2017年9月，和香港九龙仓集团旗下长沙IFS项目合作，率先在业内研究室内地图在购物中心的数字化整合。",
        diFlag: true
      },
      { value: "2017年8月，推出业内one map平台。" },

      { value: "2017年6月，创互宣布数字化整合战略。" },
      { value: "2017年5月，总部（深圳）乔迁搬入1018平米办公室。" },
      { value: "2017年1月，创互宣布云平台战略。" },
      {
        value:
          "2016年5月，创互作为业内唯一一家科技企业参加在美国拉斯维加斯的ICSC国际购物中心嘉年华。",
        diFlag: true
      },
      { value: "2016年4月，正式宣布进军中国大陆之外的市场。" },
      { value: "2016年3月，完成超过200个购物中心项目。" },

      { value: "2015年8月，创互和天虹建立战略合作伙伴关系。" },
      {
        value: "2015年3月，创互和华地国际建立战略合作伙伴关系。",
        diFlag: true
      },
      { value: "2011年8月，获得“国家高新技术企业”认证。" },
      {
        value:
          "2011年5月，获得“2D/3D地图的显示及指引或导航方法”的国家发明专利。"
      },
      { value: "2011年3月，参与建设中国移动的“惠生活”项目。", diFlag: true },
      { value: "2010年9月，业内第一个“商场电子导购系统”在深圳KKMALL上线。" },
      { value: "2010年3月，行业内第一个室内地图编辑器。" },
      { value: "2010年1月，获得国家“双软”认证企业。", diFlag: true },
      {
        value: "2009年8月，获得“大屏高清触控一体机”实用新专利技术。",
        diFlag: true
      },
      {
        value: "2008年8月，研发出中国第一台42寸高清触控一体机。",
        diFlag: true
      },
      { value: "2007年7月，公司成立。", diFlag: true }
    ],
    listData3: [
      {
        url: "./static/window/about/list3_image1.png",
        url1: "./static/mobile/about/1.png",
        title: "深圳 | 总部",
        des: "深圳市罗湖区莲塘罗湖高新技术产业第一园区<br>116栋6楼"
      },
      {
        url: "./static/window/about/list3_image2.png",
        url1: "./static/mobile/about/2.png",
        title: "武汉",
        des: "武汉洪山区高新大道718号大悦城铂悦<br>4栋304"
      },
      {
        url: "./static/window/about/list3_image3.png",
        url1: "./static/mobile/about/3.png",
        title: "北京",
        des: "北京市丰台区航丰路时代财富天地5号楼<br>2-206室"
      }
    ],
    listData4: [
      {
        url: "./static/window/about/list4_icon1.svg",
        title: "电话",
        des: "400-8337-228"
      },
      {
        url: "./static/window/about/list4_icon2.svg",
        title: "邮箱",
        des: "sw@chaunve.com"
      }
    ]
  },
  shopping: {
    t1: '购物中心解决方案',
    t2: '购物中心就是要提供出色的客户体验',
    t3: '购物中心就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的',
    t3_mobile: '购物中心就是要提供出色的客户体验，<br />而这正是创互互动指南系统所能提供的',
    t4: ' 创互的互动指南系统最初是于2008年专门为购物中心开发的。此后，它已在全球500多个购物中心中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />购物中心知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    t4_mobile: '创互的互动指南系统最初是于2008年专门为购物中心开发的。此后，它已在全球500多个购物中心中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率,并且只需触摸几下，客户即可获得所需的方向信息。<br />购物中心知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    t5: '创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: '智慧商业',
    t7: ' 顾客喜欢哪些品牌？这是第几次光临？用户体验如何提升？服务能力如何优化？<br />创互通过室内地图、室内定位及大数据分析等先进技术，助力商家为消费者带来前所未有的购物体验，获得更加丰富、更具价值、多维度的用户画像报告，实现精细化、可视化运营，降低管理成本，为商业赋能。',
    t8: '解决方案',
    t9: ' 为购物中心量身定制了许多解决方案，提供定制化服务，<br />这些解决方案其中包括：',
    t10: '我们为您的行业提供解决方案。立即联络我们',
    t10_mobile: '我们为您的行业提供解决方案。<br />立即联络我们',
    t11: '立即申请'
  },
  hospital: {
    t1: '医院解决方案',
    t2: '医院就是需要提供出色客户体验',
    t3: '医院就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的',
    t3_mobile: '医院就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的',
    t4: ' 创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />医院知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    t4_mobile: ' 创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />医院知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: '智慧医院',
    t7: '医院建筑结构复杂，人群集中，每天的人流量巨大，医护人员被问路打断，降低工作效率？无论花费大量人力财力投入导诊服务，医院导医台永远人满为患，患者挂了号不知道接下来该去哪里？<br />创互的互动指南系统和微信公众号、小程序联动，与医院系统无缝对接，给患者就医过程提供导诊服务，就医更高效，极大减轻了医院导医导诊的压力。',
    t8: '医院解决方案',
    t9: ' 除了互动指南系统，我们为医院开发了许多其他解决方案，<br />这些解决方案包括：',
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  building: {
    t1: '写字楼解决方案',
    t2: '写字楼就是需要提供出色客户体验',
    t3: '写字楼就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的',
    t3_mobile: '写字楼就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的',
    t4: '  创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />写字楼知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    t4_mobile: '创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />写字楼知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />医院知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。',
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: '智慧写字楼',
    t7: '写字楼建筑结构复杂，楼层多，电梯换乘麻烦，每天都会有多个新的访客，他们需要在这个建筑找到他们想要的目的地。<br />创互可以简化这个过程，在访客需要指引的时候，借助3D地图技术提供清晰和最准确的方向指引。<br />创互的互动指南系统和微信公众号、小程序联动，与医院系统无缝对接，给患者就医过程提供导诊服务，就医更高效，极大减轻了医院导医导诊的压力。',
    t8: '写字楼解决方案',
    t9: '除了互动指南系统，我们为写字楼开发了许多其他解决方案，<br />这些解决方案包括：',
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  traffic: {
    t1: '交通解决方案',
    t2: '交通就是需要提供出色客户体验',
    t3: `交通就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的`,
    t3_mobile: `交通就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的`,
    t4: `创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />交通枢纽知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。`,
    t4_mobile: `创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，客户即可获得所需的方向信息。<br />交通枢纽知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。`,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: '智慧交通',
    t7: '作为城市核心点、机场、高铁站、地铁站、码头等交通枢纽，已经成为每个城市重要公共设施，承载城市的梦想和高度，便捷的交通是城市发展最重要的追求之一。随着人口密度的上升，交通换乘点越来越繁忙。<br />其结果是，这些地方往往非常复杂，难以导航，游客很难知道有什么可用，更不用说找到目的地了。<br />创互通过室内地图、室内定位及大数据分析等先进技术，提供清晰和最准确的方向指引，极大提升了城市的形象。',
    t8: '交通解决方案',
    t9: ' 除了互动指南系统，我们为交通枢纽开发了许多其他解决方案，<br />这些解决方案包括：',
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  edu: {
    t1: '教育解决方案',
    t2: '校园就是要提供出色的客户体验',
    t3: `校园就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的`,
    t3_mobile: `校园就是要提供出色的客户体验，而这正是创互互动指南系统所能提供的`,
    t4: `创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />校园知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。`,
    t4_mobile: `创互的互动指南系统已在全球500多个公共场所中安装，并且该软件已经发展到如今，创互仍在互动指南系统解决方案方面处于领先地位。<br />如今，客户不仅仅喜欢互动指南系统，在数字时代的背景下，客户通常时间紧缺。他们希望信息能够快速直接地提供给他们。创互的互动指南系统可提供这种效率，并且只需触摸几下，<br />客户即可获得所需的方向信息。<br />校园知道设计就是一切，创互的互动指南系统是支持您的完美解决方案。凭借时尚的硬件设计和清晰的数字显示，创互的产品将任何空间转变为现代和先进环境。`,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: '智慧校园',
    t7: ' 通过构建一张校园地图为坐标，可视化展示校园全貌，为用户提供2D/3D地图、导航、迎新报道等便捷服务。<br />系统通过与学校管理系统结合，提供3D室内地图导览，可在一体机端和手机微信端运行，可自定义规划导航路线，提供距离短的导航路线，支持校园内跨楼宇/楼层导航。校园地图结合GPS（室外）+蓝牙（室<br />内）定位技术，实现实时导航定位。。',
    t8: '校园解决方案',
    t9: ' 除了互动指南系统，我们为学校开发了许多其他解决方案，<br />这些解决方案包括：',
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  header: {
    t1: '互动指南系统',
    t2: '静态指南系统',
    t3: '多媒体信息发布系统',
    t4: '自助寻车缴费系统',
    t5: '室内导航系统',
    t6: '室内AR导航系统',
    t7: '路易寻',
    t8: '云招商',
    t9: '商业经营可视化',
    t10: '广告位管理与预约系统',
    t11: "运维监护仪 CKIOSK M1",
    t12: "自助机 CKIOSK C1",
    t13: "自助机 CKIOSK C2",
    t14: "自助机 CKIOSK D1"
  },
  footer: {
    t1: '提升用户体验，从现在开始！',
    t2: '欢迎联系我们',
    t3: "总部（深圳）",
    t4: '地址：深圳市罗湖区莲塘罗湖高新技术产业第一园区116栋6楼',
    t5: '武汉分公司',
    t6: '地址：武汉洪山区高新大道718号大悦城铂悦4栋304',
    t7: '北京分公司',
    t8: '地址：北京市丰台区航丰路时代财富天地5号楼2-206室',
  },
  messageboard: {
    t1: '与创互解决方案联系',
    t2: '给我们发消息',
    t3: '*联系人',
    t4: '*手机',
    t5: '*邮箱',
    t6: '*公司或组织',
    t7: '*行业',
    t8: '*部门',
    t9: '*咨询的产品',
    t10: '提交',
    t11: '提示',
    t12: '谢谢，我们会尽快与您联系',
    t13: '确定',
    t14: '*请输入联系人姓名',
    t15: '*请输入手机号',
    t16: '*请输入正确的手机号码',
    t17: '*请输入正确的手机号码',
    t18: '*请输入邮箱地址',
    t19: '*请输入正确的邮箱地址',
    t20: '*请输入公司与组织',
    t21: '*请选择行业',
    t22: '*请选择部门',
    t23: '*请选择要咨询的产品',
    departmentList: [
      { lable: "品牌零售", value: "品牌零售" },
      { lable: "商场营运", value: "商场营运" },
      { lable: "电子商务", value: "电子商务" },
      { lable: "医疗健康", value: "医疗健康" },
      { lable: "教育团体", value: "教育团体" },
      { lable: "社区生活", value: "社区生活" },
      { lable: "办公大楼", value: "办公大楼" },
      { lable: "软件开发", value: "软件开发" },
      { lable: "在线媒体", value: "在线媒体" },
      { lable: "其他", value: "其他" }
    ],
    industryList: [
      { lable: "购物中心", value: "购物中心" },
      { lable: "医院", value: "医院" },
      { lable: "教育", value: "教育" },
      { lable: "交通", value: "交通" },
      { lable: "写字楼", value: "写字楼" },
      { lable: "其他", value: "其他" }
    ],
    productList: [
      { lable: "one map", value: "one map" },
      { lable: "互动指南系统", value: "互动指南系统" },
      { lable: "静态指南系统", value: "静态指南系统" },
      { lable: "多媒体信息发布系统", value: "多媒体信息发布系统" },
      { lable: "自助寻车缴费系统", value: "自助寻车缴费系统" },
      { lable: "室内导航系统", value: "室内导航系统" },
      { lable: "AR导航系统", value: "AR导航系统" },
      { lable: "云招商", value: "云招商" },
      { lable: "路易寻", value: "路易寻" },
      { lable: "其他", value: "其他" }
    ],
  },
  bi: {
    t1: '商业经营可视化',
    t2: '数据一切掌握手中',
    t3: '商业经营可视化, 令你数据一切掌握手中',
    t4: '随着商业发展的多样化以及行业竞争的激烈化，如何改善商场的运营管理，提高经济效益对整个商场来说显得尤为重要。传统的商场铺位管理模式主要是通过表格形式进行管理，可是表格一般很难准确、直观的展现商场店铺位的变更状态等信息，如铺位的租金欠缴、商品经营情况等，每次的铺位有变化都需要不停的更新记录，这样的管理模式不仅维护工作量大，还效率低下，不便于检索，并且制约了整个商场的管理和铺位的利用效率。',
    t20: '不受地域平台限制，令你随时随地即时查看数据',
    t21: `自主研发的H5图表， 数据是以秒速更新， 即时留意到現場最新状况，可同时间在不同平台上查看， 不受地域平台限制。<br>室内地图即时显示，用户可即时选择地图中的数据查看，简单直接。<br>相关人员借助可视化数据分析平台，辅助人工操作的同时将数据进行关联分析，并制作出不同的分析图表，完整展示数据分析的过程和不同的数据走向。提高经营管理和决策效率，为企业带来经济效益和企业竞争力。以帆软分析图表为例，可保存为不同格式，供相关人员调整或调阅。`,
    t5: '电脑',
    t6: '手机',
    t7: '主要功能',
    t8: '收入预警',
    t9: '通过铺位的收入情况做出合理的分析和判断，针对各个楼层的业态分布及经营状况进行有效的调整。',
    t10: '出租情况',
    t11: '将铺位出租情况以可视化的方式进行展示，为招租决策提供数据支撑，以便快速的去调查及处理铺位招租问题。',
    t12: '销售分析',
    t13: '智能统计商场整体及铺位的坪效数据，以专项图的方式进行渲染展示，可以更加直观、明了的看到销售业绩的发展趋势，结合铺位销售业绩的对比实时了解品牌商的销售情况。',
    t14: '租金管理',
    t15: '自动统计欠缴租金及逾期天数，轻松掌握租金情况，通过租金占比对铺位租金进行调整，保证铺位正常运营。',
    t16: '客流统计',
    t17: '利用高精度的人流分布数据，进行有效的营销和推广等信息，为入驻商户提供丰富准确的顾客信息，助力商场做到以实际数据为依据与商户进行租约洽谈、指导经营，实现精细化运营，提高管理效率，减少运营成本。',
    t18: '权限管理',
    t19: '针对保密和业务的需要，系统支持用户权限管理控制，支持从数据包层面控制不同用户对于数据的权限。基于访问控制列表和角色控制的权限设置，实现对大数据环境下，数据库系统行列级别的权限控制。',
  },
  ads: {
    t1: '广告管理与预约系统',
    t2: '全场景广告位资源数字管家',
    t3: '构建全场景广告位地图，广告管理、预约在线化',
    t4: '基于创互科技的地图能力，构建基于位置分布的广告位地图，实现在线管理、预约、审批，三管齐下，助力商场广告运营业务。相比EXCEL管理模式，广告位地图突破静态、繁杂、更新不及时的问题，塑造了集位置、实景、朝向的立体展现形式，加之以按分布区域、广告排期表等多维度条件筛选，大大提升了操作便利程度、增强了广告主预订意向。',
    t5: '功能介绍',
    t6: '广告位管理',
    t7: '地图中双击即可精确地创建广告点位，并通过广告大类-单个点位的二级管理模式，实现批量管理',
    t8: '广告位地图支持缩放、拖动查看各位置的广告分布、点位详情',
    t9: '智能排期表',
    t10: '一览点位预约中、排期中、投放中、已投放的品牌',
    t11: '日历式呈现点位空闲时段，实现无冲突预约',
    t12: '预约与审批',
    t13: '广告主',
    t14: '按意向时段选择投放点位',
    t15: '按意向地段选择投放点位',
    t16: '运营者',
    t17: '随时随地在线审批，及时反馈审批结果',
    t18: '支持多级审批，跟踪审批进度',
    t19: '报表统计',
    t20: '从广告位资源分布、租用状态等维度统计，便于运营者及时了解资源状况',
    t21: '从预约申请量、广告主业态等维度统计，为运营者规划、调整广告位提供数据依据',
    t22: '从可预约广告时间、空间分布等维度统计，降低广告主决策难度',
  }
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js